export const FIELD_FILE_ADVANCED_MAX_ALLOWED_SIZE = 20971520; // 20 Mo
